import {SavedFlurstueck} from "./savedFlurstueck";

export class SavedFlur{

  constructor() {
    this.flurstuecke.push(new SavedFlurstueck())
  }

  id: number;
  number: string;

  flurstuecke: Array<SavedFlurstueck> = [];

  addFlurstueck(){
    this.flurstuecke.push(new SavedFlurstueck());
  }

}
